import React from "react";
import PropTypes from "prop-types";

import CommentFilterItem from "./CommentFilterItem";

export default function CommentFilter({ filters, children }) {
  if (filters.length === 0) {
    return null;
  }

  return (
    <div data-test="comment-filters">
      <span style={{ color: "grey", marginLeft: "3em", marginRight: "1em" }}>
        Showing only comments for:
      </span>
      {filters.map((appliedFilter) => {
        return (
          <CommentFilterItem
            key={appliedFilter.type}
            typeName={appliedFilter.type}
            iconName={appliedFilter.iconName}
            title={appliedFilter.title}
            removeFilter={appliedFilter.clear}
          />
        );
      })}
      {children}
    </div>
  );
}

CommentFilter.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      iconName: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      clear: PropTypes.func.isRequired,
    })
  ).isRequired,
  children: PropTypes.node,
};

CommentFilter.defaultProps = {
  children: null,
};
